export default {
  message: 'Seu empréstimo será pago',
};
